import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

export interface RemoveConfirmModalProps {
	isOpen: boolean;
	competencyName: string;
	onConfirm: () => void;
	onClose: () => void;
}

const RemoveConfirmModal: React.FC<RemoveConfirmModalProps> = ({ isOpen, competencyName, onConfirm, onClose }) => (
	<ModalBase isOpen={isOpen} onClose={onClose}>
		<div className="box-border w-[432px] px-6 pb-6">
			<Text size="sub-heading" weight="semi-bold" dangerouslySetClassName="text-center">
				Remove Competency?
			</Text>
			<Text size="paragraph-1" dangerouslySetClassName="mt-4 text-center">
				Are you sure you want to remove &quot;{competencyName}&quot; from this role?
			</Text>
			<div className="mt-6 flex justify-center gap-2">
				<div>
					<ButtonStandard size="large" variant="outline" color="neutral" onClick={onClose}>
						Cancel
					</ButtonStandard>
				</div>
				<div>
					<ButtonStandard size="large" color="primary" onClick={onConfirm}>
						Yes, Remove
					</ButtonStandard>
				</div>
			</div>
		</div>
	</ModalBase>
);

export default RemoveConfirmModal;
